import { sanitizeValue } from '@miq/catalog';
import { FloorFlatSpace } from './spaces-details/spaces-details.component';
import { TenantSpaceFormatted } from './tenant-summary/tenant-summary.model';
import { DASH } from '@miq/utils';

/**
 *
 * @param spaces
 * @returns groupes spaces by property type
 * that are disabled (non-rentable and active property types are not grouped)
 * (MIQ-28824)
 */
export const groupByDisabledUsages = (
  spaces: (FloorFlatSpace | TenantSpaceFormatted)[]
): (FloorFlatSpace | TenantSpaceFormatted)[] => {
  const groupedData = spaces.reduce((acc, space) => {
    if (space.isSelectedPropertyType || space.propertyType === 'Non-Rentable') {
      acc.push(space);
      return acc;
    }

    const existingSpace = acc.find(s => s.propertyType === space.propertyType && !s.isSelectedPropertyType);
    const columnConfig = { dataType: 'numeric', options: { format: '0.0-0' } };
    if (existingSpace) {
      existingSpace.sfRaw = (existingSpace.sfRaw || 0) + (space.sfRaw || 0);
      existingSpace.sf = sanitizeValue(existingSpace.sfRaw, columnConfig) ?? DASH;
      return acc;
    }

    acc.push(space);
    return acc;
  }, []);
  return groupedData;
};
